import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { SendDigitalSignatureRequestClientResponse } from '../@types/digitalSignature/sendDigitalSignature'

type Store = {
  sendDigitalSignature: SendDigitalSignatureRequestClientResponse | null
  setSendDigitalSignature: (
    value: SendDigitalSignatureRequestClientResponse,
  ) => void
}

export const useSendDigitalSignatureStore = create<Store>()(
  devtools(
    (set) => ({
      sendDigitalSignature: null,
      setSendDigitalSignature: (sendDigitalSignature) =>
        set({ sendDigitalSignature }),
    }),
    { name: 'SendDigitalSignature' },
  ),
)
